import { openLotteryForRain } from '@this/services/lottery';
const state = {
  showLotteryResult: false,
  lotteryResult: { category: 'link' },
};

const mutations = {
  setShowLotteryResult(state, bool) {
    state.showLotteryResult = bool;
  },
  setLotteryResult(state, obj) {
    state.lotteryResult = obj;
  },
};

const actions = {
  // 事件
  async clickLottery({ dispatch, commit }, score) {
    await dispatch('openLottery', score);
    await dispatch('coupon/getCoupons', false, { root: true });
    dispatch('changeShowLotteryResult');
    commit('user/rainChance', true, { root: true });
    commit('rpRain/setShowVideo', true, { root: true });
  },
  clickConfirm({ state, dispatch }) {
    const {
      lotteryResult: { link },
    } = state;
    dispatch('goto/gotoLink', link, { root: true });
  },
  changeShowLotteryResult({ commit, state }, bool) {
    const showLotteryResult = bool ?? !state.showLotteryResult;
    commit('setShowLotteryResult', showLotteryResult);
  },
  // 步骤
  async openLottery({ commit }, score) {
    let res = await openLotteryForRain({
      score,
    });
    const lotteryResult = res.data;
    commit('setLotteryResult', lotteryResult);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
